var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state-button",class:[_vm.readerSlug, { populated: _vm.populated, selected: _vm.selected }],on:{"click":_vm.onClick}},[_vm._t("default",[_vm._v(" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }